import { Component, OnInit, OnChanges, Input, ChangeDetectorRef } from '@angular/core';
import { DataType } from 'src/app/model/data-type.enum';
import { FileInfoInterface } from 'src/app/model/marketplace/file-info-interface';
import { FileServiceService } from 'src/app/services/file-service/file-service.service';
import { first } from 'rxjs/operators';

@Component({
    selector: 'app-detail-display-document-list',
    templateUrl: './detail-display-document-list.component.html',
    styleUrls: ['./detail-display-document-list.component.css'],
    standalone: false
})
export class DetailDisplayDocumentListComponent implements OnInit, OnChanges {
    @Input()
    fileIds: string[];

    @Input()
    public dataType: DataType;

    @Input() public onSummary?: boolean = false;

    public files: FileInfoInterface[];
    public ripple: string = 'rgba(var(--app-accent-rgb), 0.08)';

    constructor(
        private fileService: FileServiceService,
        private cd: ChangeDetectorRef
    ) {}

    ngOnChanges() {
        if (this.fileIds == null || this.fileIds.length === 0) {
            this.files = [];
            this.cd.detectChanges();
            return;
        }

        this.loadDocuments();
        this.cd.detectChanges();
    }

    ngOnInit() {
        this.loadDocuments();
    }

    private loadDocuments() {
        if (this.fileIds == null || this.fileIds.length === 0) {
            this.files = [];
            return;
        }

        if (this.dataType === DataType.CERTIFICATION) {
            this.ripple = 'rgba(var(--app-accent-rgb), 0.08)';
        } else {
            this.ripple = 'var(--app-surface-variant)';
        }
        this.loadDocumentMetaData();
    }

    loadDocumentMetaData() {
        this.fileService
            .getMetaDataForFiles(this.fileIds)
            .pipe(first())
            .subscribe((fileInfos: FileInfoInterface[]) => {
                const orderedFileList = [];
                for (const fileId of this.fileIds) {
                    orderedFileList.push(
                        fileInfos.find((fileInfo) => fileInfo.id === fileId)
                    );
                }
                this.files = orderedFileList;
            });
    }

    private getDate(dateString: string): Date {
        return new Date(dateString);
    }

    private getFormattedFileSize(fileSize: string): string {
        const postfixOptions = ['B', 'KB', 'MB'];
        let result = '';
        let postfixIndex = 0;
        let sizeAsNumber = Number(fileSize);
        if (isNaN(sizeAsNumber)) {
            return result;
        }
        while (sizeAsNumber > 1000) {
            sizeAsNumber /= 1000;
            postfixIndex++;
        }
        return (
            parseFloat('' + sizeAsNumber).toFixed(1) +
            ' ' +
            postfixOptions[postfixIndex]
        );
    }

    onClick(fileUrl: string): void {
        window.open(fileUrl);
    }
}
